/**
 * One page of a server-paged list, as the remediation, digitization and storage endpoints answer
 * `?page=&limit=` (VTK-2045).
 */
export interface PagedItems<T> {
  items: T[];
  total: number;
}

/** The page a list asks the server for. `page` is 1-based, as the API counts. */
export interface PageQuery {
  page: number;
  limit: number;
}

/**
 * Accept either shape. Until the backend that pages these lists is deployed, the same request still
 * gets the old bare array back, and the screen should show it rather than break. The array is the
 * whole list, so it is sliced to the requested page here.
 */
export function toPagedItems<T>(
  data: PagedItems<T> | T[] | null | undefined,
  page?: PageQuery
): PagedItems<T> {
  if (Array.isArray(data)) {
    if (!page) return { items: data, total: data.length };
    const start = (page.page - 1) * page.limit;
    return { items: data.slice(start, start + page.limit), total: data.length };
  }
  return { items: data?.items ?? [], total: data?.total ?? 0 };
}

/** `?page=&limit=` for a request URL. */
export function pageQueryString({ page, limit }: PageQuery): string {
  return new URLSearchParams({ page: String(page), limit: String(limit) }).toString();
}
